
export interface Package {
  object_type?: string;
  id: number;
  package_group_id: number;
  code: string;
  account_code?: string;
  title: string;
  description: string;
  category: string;
  currency: string;
  price: number;
  is_plan: boolean;
  allow_multiple: boolean;
  discount_class?: string;
  interval: Interval;
  discount_rate: number;
  shippable?: boolean;
  long_description: string;
  type: Type;
  qty: number;
  sku: number;
  version: number;
  tax_rate: number;
  tax_value: number;
  total: number;
  is_valid: boolean;
  is_public: boolean;
  expiry?: string;
  available_from?: string;
  created_at: string;
  updated_at: string;
  is_visible_now?: string;
  is_visible_state?: string;

  length?: number;
  width?: number;
  height?: number;
  weight?: number;

  short_code?: string;
  bundle_id?: number;
}

export enum Interval {
  Once = "once",
  Month = "month",
  Year = "year",
}

export enum Type {
  Prepaid = "prepaid",
  Postpaid = "postpaid",
}

function Format(p: Package) {
  p.id = + p.id;
  p.package_group_id = + p.package_group_id;
  p.price = + p.price;
  p.discount_rate = + p.discount_rate;
  p.qty = + p.qty;
  p.sku = + p.sku;
  p.version = + p.version;
  p.tax_rate = + p.tax_rate;
  p.tax_value = + p.tax_value;
  p.total = + p.total;
  p.length = +(p.length || 0);
  p.width = +(p.width || 0);
  p.height = +(p.height || 0);
  p.weight = +(p.weight || 0);

  return p;
}

function New(): Package {
  return {
    id: 0,
    package_group_id: 0,
    code: '',
    title: '',
    description: '',
    category: '',
    currency: '',
    price: 0,
    is_plan: false,
    allow_multiple: false,
    interval: Interval.Once,
    discount_rate: 0,
    long_description: '',
    type: Type.Prepaid,
    qty: 0,
    sku: 0,
    version: 0,
    tax_rate: 0,
    tax_value: 0,
    total: 0,
    is_valid: false,
    is_public: false,
    created_at: '',
    updated_at: '',
  };
}

function HasSizeAndWeight(p: Package): boolean {
  p.length = +(p.length || 0);
  p.width = +(p.width || 0);
  p.height = +(p.height || 0);
  p.weight = +(p.weight || 0);

  return p.length > 0 && p.width > 0 && p.height > 0 && p.weight > 0;
}

export default {
  Format,
  New,
  HasSizeAndWeight
};
